import React from 'react';
import { DeleteModalForm } from './form';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon, SimpleModal, ExpandedTooltip } from '@livable/saas-react-components';
export const DeleteModal = observer(_ref => {
  let data = _ref.data,
    callback = _ref.callback;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('Delete Credential'),
    trigger: /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: t('Delete credential'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }))),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(DeleteModalForm, {
    data: data,
    callback: callback
  }));
});